import React, { useState, useCallback, useEffect } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  shareCandidate,
  FETCH_CANDIDATE_BY_ID,
  fetchCandidateBaseByID
} from "../../store/actions/candidates";
import CandidateModal from "../../components/CandidateModal";
import {
  WrapperAction,
  Title
} from "../../components/CandidateModal/WrapperAction";
import ShareCandidatesModal from "../Opportunity/routes/OpportunityCandidates/ShareCandidatesModal";
import { isLoading } from "../../utils/actions";

const CandidatesBaseDetails = ({ onNext, onPrev, onClose }) => {
  const { t } = useTranslation();

  const params = useParams();
  const dispatch = useDispatch();
  const loading = useSelector(state => isLoading(FETCH_CANDIDATE_BY_ID, state));

  const candidate = useSelector(state => state.candidates.selected);
  const [shareCandidateModalVisible, setShareCandidateModalVisible] = useState(
    false
  );

  useEffect(() => {
    dispatch(fetchCandidateBaseByID({ id: params.candidateId }));
  }, [dispatch, params.candidateId]);

  const handleCandidateShare = useCallback(
    opportunities =>
      dispatch(
        shareCandidate({
          candidate,
          opportunities
        })
      ),
    [candidate, dispatch]
  );
  return (
    <>
      <ShareCandidatesModal
        onOk={handleCandidateShare}
        onClose={() => setShareCandidateModalVisible(false)}
        visible={shareCandidateModalVisible}
      />
      <CandidateModal
        loading={loading}
        candidate={candidate}
        onNext={onNext}
        onPrev={onPrev}
        onClose={onClose}
        actions={[
          <WrapperAction key="share" colorHover="primary">
            <Button
              onClick={() => setShareCandidateModalVisible(true)}
              data-test="share-candidate-btn"
              key="share"
              type="primary"
              icon="export"
              shape="circle"
            />
            <Title>
              {t(
                "opportunity:candidates.multipleSelection.shareCandidateToOpp"
              )}
            </Title>
          </WrapperAction>
        ]}
      />
    </>
  );
};

export default CandidatesBaseDetails;
